import { createSelector } from '@reduxjs/toolkit';
import { selectActivityImagesFromDetailState } from 'component/page/detail/store/detail.selectors';
import { selectBehaviorFromBootstrap, selectCmsFromBootstrap } from 'store/slice/bootstrap';
import { CmsValue } from 'core/type/BootstrapConfig.types';
import { Image } from 'gql/autogen/Image';
import React from 'react';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import {
    ActivitiesMosaicGalleryClickEventActivitiesFieldsV1,
    ActivitiesViewAllImagesButtonClickEventActivitiesFieldsV1,
} from '@agoda/analytics-messages-definition-activities/events.split';
import {
    ActivitiesMosaicGalleryClickEventActivitiesManifestV1,
    ActivitiesViewAllImagesButtonClickEventActivitiesManifestV1,
} from '@agoda/analytics-messages-definition-activities/manifest/events';
import { ScreenSize, selectScreenSize } from 'store/slice/screen';
import { MosaicGallerySpecificProps } from 'component/page/detail/DetailPageModularize/detailPageModularize.types';

interface StateProps {
    cms: CmsValue;
    images: Image[];
    screenSize: ScreenSize;
}

interface DispatchProps {
    onImageClick: (event: React.MouseEvent, index: number, isViewAllImages: boolean) => void;
}

export type Props = StateProps & DispatchProps & MosaicGallerySpecificProps;

export const mapStateToProps = createSelector(
    selectCmsFromBootstrap,
    selectActivityImagesFromDetailState,
    selectScreenSize,
    selectBehaviorFromBootstrap,
    (cms, images, screenSize, behaviors): StateProps => {
        return {
            cms,
            images,
            screenSize,
        };
    },
);

export const mapDispatchToProps = (): DispatchProps => ({
    onImageClick: (event: React.MouseEvent, index: number, isViewAllImages = false) => {
        if (isViewAllImages) {
            trackElementEvent<ActivitiesViewAllImagesButtonClickEventActivitiesFieldsV1>(
                ActivitiesViewAllImagesButtonClickEventActivitiesManifestV1.ids,
                {},
                { action_element_index: index + 1 },
            );
        } else {
            trackElementEvent<ActivitiesMosaicGalleryClickEventActivitiesFieldsV1>(
                ActivitiesMosaicGalleryClickEventActivitiesManifestV1.ids,
                {},
                { action_element_index: index + 1 },
            );
        }
    },
});
